// extracted by mini-css-extract-plugin
export default {"mobile":"ncQLmxYkY05cftXDQAoX"};